import { mapStoreGetters, storeTypes } from '/@/vuex/helpers'

export default {
  computed: {
    ...mapStoreGetters(storeTypes.SETTINGS, ['log.paths.subscription']),
  },
}
